var exports = {
  "tT": "DecoratedDownloadActionMenu__TxVHUT",
  "Mt": "MonaPixel__n2jGHC",
  "tZ": "ButtonOverlay__WQwkrH",
  "yK": "ButtonOverlayText__7mSIIZ",
  "mg": "ButtonOverlayItem__QZKQ1B",
};

module.exports = exports;
